import { CampaignMatchedGivingSetting } from '@web/graphql-types'
import { usePageStore } from '../libs/hooks/usePageStore'
import { checkIsHiddenFromDates } from '@web/components/utils/dateUtils'
import { useEffect } from 'react'
import { toSearchParams } from '../utils'

type MatchedGivingHandlerProps = {
  matchedGivings: CampaignMatchedGivingSetting[] | null | undefined
}

// calculates if a matched giving is active or not and
// stores in state
const MatchedGivingHandler = ({ matchedGivings }: MatchedGivingHandlerProps) => {
  const campaignId = usePageStore((state) => state.campaignId)
  const isLiveMode = usePageStore((state) => state.isLiveMode)

  useEffect(() => {
    if (!matchedGivings?.length || !campaignId) {
      return
    }

    const checkMatchedGivings = async () => {
      matchedGivings.forEach(async (matchedGiving) => {
        if (!checkIsHiddenFromDates(matchedGiving.startAt, matchedGiving.endAt, null)) {
          const amount = await fetch(`
            /api/matched-giving?${toSearchParams({ campaignId, matchedGivingId: matchedGiving.id, isLiveMode })}`)
            .then((res) => res.json())
            .then((data) => data.amount)
            .catch(() => 0)

          let index = -1
          for (let i = 0; i < matchedGiving.rounds.length; i++) {
            if (amount < matchedGiving.rounds[i].endFundRange) {
              index = i
              break
            }
          }

          if (index > -1) {
            usePageStore.setState({
              activeMatchedGiving: {
                ...matchedGiving,
                activeRound: index,
              },
            })
          }
        }
      })
    }

    checkMatchedGivings()
  }, [matchedGivings?.length, campaignId])
  return null
}

export default MatchedGivingHandler
